export default {
  "countries": [
    {
      "id" : 87,
      "code": "643",
      "name": "Россия",
      "fullname": "Российская Федерация",
      "alpha2": "RU",
      "alpha3": "RUS",
      "gisp_id": 235
    },
    {
      "id" : 88,
      "code": "031",
      "name": "Азербайджан",
      "fullname": "Республика Азербайджан",
      "alpha2": "AZ",
      "alpha3": "AZE",
      "gisp_id": 75
    },
    {
      "id" : 89,
      "code": "051",
      "name": "Армения",
      "fullname": "Республика Армения",
      "alpha2": "AM",
      "alpha3": "ARM",
      "gisp_id": 81
    },
    {
      "id" : 90,
      "code": "268",
      "name": "Грузия",
      "fullname": "Грузия",
      "alpha2": "GE",
      "alpha3": "GEO",
      "gisp_id": 143
    },
    {
      "id" : 91,
      "code": "398",
      "name": "Казахстан",
      "fullname": "Республика Казахстан",
      "alpha2": "KZ",
      "alpha3": "KAZ",
      "gisp_id": 169
    },
    {
      "id" : 92,
      "code": "496",
      "name": "Монголия",
      "fullname": "Монголия",
      "alpha2": "MN",
      "alpha3": "MNG",
      "gisp_id": 194
    },
    {
      "id" : 93,
      "code": "498",
      "name": "Молдова",
      "fullname": "Республика Молдова",
      "alpha2": "MD",
      "alpha3": "MDA",
      "gisp_id": 195
    },
    {
      "id" : 94,
      "code": "762",
      "name": "Таджикистан",
      "fullname": "Республика Таджикистан",
      "alpha2": "TJ",
      "alpha3": "TJK",
      "gisp_id": 36
    },
    {
      "id" : 95,
      "code": "586",
      "name": "Пакистан",
      "fullname": "Исламская Республика Пакистан",
      "alpha2": "PK",
      "alpha3": "PAK",
      "gisp_id": 220
    },
    {
      "id" : 96,
      "code": "860",
      "name": "Узбекистан",
      "fullname": "Республика Узбекистан",
      "alpha2": "UZ",
      "alpha3": "UZB",
      "gisp_id": 60
    },
    {
      "id" : 97,
      "code": "895",
      "name": "Абхазия",
      "fullname": "Республика Абхазия",
      "alpha2": "AB",
      "alpha3": "ABH",
      "gisp_id": 65
    },
    {"id":1495,"code":"112","name":"Белоруссия","full_name":"Белоруссия","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1496,"code":"100","name":"Болгария","full_name":"Болгария","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1497,"code":"348","name":"Венгрия","full_name":"Венгрия","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1499,"code":"616","name":"Польша","full_name":"Польша","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1500,"code":"642","name":"Румыния","full_name":"Румыния","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1501,"code":"703","name":"Словакия","full_name":"Словакия","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1502,"code":"203","name":"Чехия","full_name":"Чехия","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1504,"code":"688","name":"Сербия","full_name":"Сербия","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1505,"code":"705","name":"Словения","full_name":"Словения","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1506,"code":"499","name":"Черногория","full_name":"Черногория","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1507,"code":"417","name":"Кыргызстан","full_name":"Кыргызстан","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1508,"code":"795","name":"Туркмения","full_name":"Туркмения","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1509,"code":"440","name":"Литва","full_name":"Литва","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1510,"code":"428","name":"Латвия","full_name":"Латвия","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1511,"code":"233","name":"Эстония","full_name":"Эстония","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1512,"code":"804","name":"Украина","full_name":"Украина","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1498,"code":"498","name":"Молдавия","full_name":"Молдавия","alpha2":"","alpha3":"","gisp_id":""},
    {"id":1503,"code":"008","name":"Албания","full_name":"Албания","alpha2":"","alpha3":"","gisp_id":""}
  ],
  "regions": [
    {
      "code": "01",
      "name": "Республика Адыгея (Адыгея)",
      "parent_id": 87,
      "nsi_id": 87,
      "dm_region_id": 245,
      "gisp_id": 3464,
      "id": 1
    },
    {
      "code": "02",
      "name": "Республика Башкортостан",
      "parent_id": 87,
      "nsi_id": 13,
      "dm_region_id": 230,
      "gisp_id": 3470,
      "id": 2
    },
    {
      "code": "03",
      "name": "Республика Бурятия",
      "parent_id": 87,
      "nsi_id": 49,
      "dm_region_id": 255,
      "gisp_id": 3473,
      "id": 3
    },
    {
      "code": "04",
      "name": "Республика Алтай",
      "parent_id": 87,
      "nsi_id": 48,
      "dm_region_id": 198,
      "gisp_id": 3465,
      "id": 4
    },
    {
      "code": "05",
      "name": "Республика Дагестан",
      "parent_id": 87,
      "nsi_id": 40,
      "dm_region_id": 270,
      "gisp_id": 3478,
      "id": 5
    },
    {
      "code": "06",
      "name": "Республика Ингушетия",
      "parent_id": 87,
      "nsi_id": 41,
      "dm_region_id": 234,
      "gisp_id": 3482,
      "id": 6
    },
    {
      "code": "07",
      "name": "Кабардино-Балкарская Республика",
      "parent_id": 87,
      "nsi_id": 42,
      "dm_region_id": 225,
      "gisp_id": 3484,
      "id": 7
    },
    {
      "code": "08",
      "name": "Республика Калмыкия",
      "parent_id": 87,
      "nsi_id": 95,
      "dm_region_id": 195,
      "gisp_id": 3486,
      "id": 8
    },
    {
      "code": "09",
      "name": "Карачаево-Черкесская Республика",
      "parent_id": 87,
      "nsi_id": 43,
      "dm_region_id": 212,
      "gisp_id": 3489,
      "id": 9
    },
    {
      "code": "10",
      "name": "Республика Карелия",
      "parent_id": 87,
      "nsi_id": 28,
      "dm_region_id": 200,
      "gisp_id": 3490,
      "id": 10
    },
    {
      "code": "11",
      "name": "Республика Коми",
      "parent_id": 87,
      "nsi_id": 29,
      "dm_region_id": 199,
      "gisp_id": 3493,
      "id": 11
    },
    {
      "code": "12",
      "name": "Республика Марий Эл",
      "parent_id": 87,
      "nsi_id": 14,
      "dm_region_id": 266,
      "gisp_id": 3503,
      "id": 12
    },
    {
      "code": "13",
      "name": "Республика Мордовия",
      "parent_id": 87,
      "nsi_id": 15,
      "dm_region_id": 237,
      "gisp_id": 3504,
      "id": 13
    },
    {
      "code": "14",
      "name": "Республика Саха (Якутия)",
      "parent_id": 87,
      "nsi_id": 3,
      "dm_region_id": 262,
      "gisp_id": 3524,
      "id": 14
    },
    {
      "code": "15",
      "name": "Республика Северная Осетия - Алания",
      "parent_id": 87,
      "nsi_id": 44,
      "dm_region_id": 240,
      "gisp_id": 3528,
      "id": 15
    },
    {
      "code": "16",
      "name": "Республика Татарстан (Татарстан)",
      "parent_id": 87,
      "nsi_id": 16,
      "dm_region_id": 239,
      "gisp_id": 3532,
      "id": 16
    },
    {
      "code": "17",
      "name": "Республика Тыва",
      "parent_id": 87,
      "nsi_id": 50,
      "dm_region_id": 231,
      "gisp_id": 3536,
      "id": 17
    },
    {
      "code": "18",
      "name": "Удмуртская Республика",
      "parent_id": 87,
      "nsi_id": 17,
      "dm_region_id": 209,
      "gisp_id": 3538,
      "id": 18
    },
    {
      "code": "19",
      "name": "Республика Хакасия",
      "parent_id": 87,
      "nsi_id": 51,
      "dm_region_id": 217,
      "gisp_id": 3541,
      "id": 19
    },
    {
      "code": "20",
      "name": "Чеченская Республика",
      "parent_id": 87,
      "nsi_id": 45,
      "dm_region_id": 241,
      "gisp_id": 3544,
      "id": 20
    },
    {
      "code": "21",
      "name": "Чувашская Республика - Чувашия",
      "parent_id": 87,
      "nsi_id": 18,
      "dm_region_id": 193,
      "gisp_id": 3545,
      "id": 21
    },
    {
      "code": "22",
      "name": "Алтайский край",
      "parent_id": 87,
      "nsi_id": 52,
      "dm_region_id": 277,
      "gisp_id": 3466,
      "id": 22
    },
    {
      "code": "23",
      "name": "Краснодарский край",
      "parent_id": 87,
      "nsi_id": 88,
      "dm_region_id": 254,
      "gisp_id": 3495,
      "id": 23
    },
    {
      "code": "24",
      "name": "Красноярский край",
      "parent_id": 87,
      "nsi_id": 54,
      "dm_region_id": 213,
      "gisp_id": 3496,
      "id": 24
    },
    {
      "code": "25",
      "name": "Приморский край",
      "parent_id": 87,
      "nsi_id": 5,
      "dm_region_id": 222,
      "gisp_id": 3517,
      "id": 25
    },
    {
      "code": "26",
      "name": "Ставропольский край",
      "parent_id": 87,
      "nsi_id": 46,
      "dm_region_id": 269,
      "gisp_id": 3530,
      "id": 26
    },
    {
      "code": "27",
      "name": "Хабаровский край",
      "parent_id": 87,
      "nsi_id": 6,
      "dm_region_id": 256,
      "gisp_id": 3540,
      "id": 27
    },
    {
      "code": "28",
      "name": "Амурская область",
      "parent_id": 87,
      "nsi_id": 7,
      "dm_region_id": 242,
      "gisp_id": 3467,
      "id": 28
    },
    {
      "code": "29",
      "name": "Архангельская область",
      "parent_id": 87,
      "nsi_id": 30,
      "dm_region_id": 229,
      "gisp_id": 3468,
      "id": 29
    },
    {
      "code": "30",
      "name": "Астраханская область",
      "parent_id": 87,
      "nsi_id": 89,
      "dm_region_id": 214,
      "gisp_id": 3469,
      "id": 30
    },
    {
      "code": "31",
      "name": "Белгородская область",
      "parent_id": 87,
      "nsi_id": 68,
      "dm_region_id": 197,
      "gisp_id": 3471,
      "id": 31
    },
    {
      "code": "32",
      "name": "Брянская область",
      "parent_id": 87,
      "nsi_id": 69,
      "dm_region_id": 246,
      "gisp_id": 3472,
      "id": 32
    },
    {
      "code": "33",
      "name": "Владимирская область",
      "parent_id": 87,
      "nsi_id": 70,
      "dm_region_id": 251,
      "gisp_id": 3474,
      "id": 33
    },
    {
      "code": "34",
      "name": "Волгоградская область",
      "parent_id": 87,
      "nsi_id": 90,
      "dm_region_id": 274,
      "gisp_id": 3475,
      "id": 34
    },
    {
      "code": "35",
      "name": "Вологодская область",
      "parent_id": 87,
      "nsi_id": 31,
      "dm_region_id": 243,
      "gisp_id": 3476,
      "id": 35
    },
    {
      "code": "36",
      "name": "Воронежская область",
      "parent_id": 87,
      "nsi_id": 71,
      "dm_region_id": 257,
      "gisp_id": 3477,
      "id": 36
    },
    {
      "code": "37",
      "name": "Ивановская область",
      "parent_id": 87,
      "nsi_id": 72,
      "dm_region_id": 272,
      "gisp_id": 3481,
      "id": 37
    },
    {
      "code": "38",
      "name": "Иркутская область",
      "parent_id": 87,
      "nsi_id": 55,
      "dm_region_id": 249,
      "gisp_id": 3483,
      "id": 38
    },
    {
      "code": "39",
      "name": "Калининградская область",
      "parent_id": 87,
      "nsi_id": 32,
      "dm_region_id": 208,
      "gisp_id": 3485,
      "id": 39
    },
    {
      "code": "40",
      "name": "Калужская область",
      "parent_id": 87,
      "nsi_id": 73,
      "dm_region_id": 275,
      "gisp_id": 3487,
      "id": 40
    },
    {
      "code": "41",
      "name": "Камчатский край",
      "parent_id": 87,
      "nsi_id": 4,
      "dm_region_id": 263,
      "gisp_id": 3488,
      "id": 41
    },
    {
      "code": "42",
      "name": "Кемеровская область",
      "parent_id": 87,
      "nsi_id": 56,
      "dm_region_id": 238,
      "gisp_id": 3491,
      "id": 42
    },
    {
      "code": "43",
      "name": "Кировская область",
      "parent_id": 87,
      "nsi_id": 20,
      "dm_region_id": 215,
      "gisp_id": 3492,
      "id": 43
    },
    {
      "code": "44",
      "name": "Костромская область",
      "parent_id": 87,
      "nsi_id": 74,
      "dm_region_id": 206,
      "gisp_id": 3494,
      "id": 44
    },
    {
      "code": "45",
      "name": "Курганская область",
      "parent_id": 87,
      "nsi_id": 61,
      "dm_region_id": 207,
      "gisp_id": 3498,
      "id": 45
    },
    {
      "code": "46",
      "name": "Курская область",
      "parent_id": 87,
      "nsi_id": 75,
      "dm_region_id": 205,
      "gisp_id": 3499,
      "id": 46
    },
    {
      "code": "47",
      "name": "Ленинградская область",
      "parent_id": 87,
      "nsi_id": 33,
      "dm_region_id": 248,
      "gisp_id": 3500,
      "id": 47
    },
    {
      "code": "48",
      "name": "Липецкая область",
      "parent_id": 87,
      "nsi_id": 76,
      "dm_region_id": 250,
      "gisp_id": 3501,
      "id": 48
    },
    {
      "code": "49",
      "name": "Магаданская область",
      "parent_id": 87,
      "nsi_id": 8,
      "dm_region_id": 194,
      "gisp_id": 3502,
      "id": 49
    },
    {
      "code": "50",
      "name": "Московская область",
      "parent_id": 87,
      "nsi_id": 77,
      "dm_region_id": 276,
      "gisp_id": 3506,
      "id": 50
    },
    {
      "code": "51",
      "name": "Мурманская область",
      "parent_id": 87,
      "nsi_id": 34,
      "dm_region_id": 268,
      "gisp_id": 3507,
      "id": 51
    },
    {
      "code": "52",
      "name": "Нижегородская область",
      "parent_id": 87,
      "nsi_id": 21,
      "dm_region_id": 201,
      "gisp_id": 3509,
      "id": 52
    },
    {
      "code": "53",
      "name": "Новгородская область",
      "parent_id": 87,
      "nsi_id": 35,
      "dm_region_id": 235,
      "gisp_id": 3510,
      "id": 53
    },
    {
      "code": "54",
      "name": "Новосибирская область",
      "parent_id": 87,
      "nsi_id": 57,
      "dm_region_id": 247,
      "gisp_id": 3511,
      "id": 54
    },
    {
      "code": "55",
      "name": "Омская область",
      "parent_id": 87,
      "nsi_id": 58,
      "dm_region_id": 211,
      "gisp_id": 3512,
      "id": 55
    },
    {
      "code": "56",
      "name": "Оренбургская область",
      "parent_id": 87,
      "nsi_id": 22,
      "dm_region_id": 223,
      "gisp_id": 3513,
      "id": 56
    },
    {
      "code": "57",
      "name": "Орловская область",
      "parent_id": 87,
      "nsi_id": 78,
      "dm_region_id": 227,
      "gisp_id": 3514,
      "id": 57
    },
    {
      "code": "58",
      "name": "Пензенская область",
      "parent_id": 87,
      "nsi_id": 23,
      "dm_region_id": 219,
      "gisp_id": 3515,
      "id": 58
    },
    {
      "code": "59",
      "name": "Пермский край",
      "parent_id": 87,
      "nsi_id": 19,
      "dm_region_id": 258,
      "gisp_id": 3516,
      "id": 59
    },
    {
      "code": "60",
      "name": "Псковская область",
      "parent_id": 87,
      "nsi_id": 36,
      "dm_region_id": 264,
      "gisp_id": 3518,
      "id": 60
    },
    {
      "code": "61",
      "name": "Ростовская область",
      "parent_id": 87,
      "nsi_id": 91,
      "dm_region_id": 271,
      "gisp_id": 3519,
      "id": 61
    },
    {
      "code": "62",
      "name": "Рязанская область",
      "parent_id": 87,
      "nsi_id": 79,
      "dm_region_id": 203,
      "gisp_id": 3520,
      "id": 62
    },
    {
      "code": "63",
      "name": "Самарская область",
      "parent_id": 87,
      "nsi_id": 24,
      "dm_region_id": 236,
      "gisp_id": 3521,
      "id": 63
    },
    {
      "code": "64",
      "name": "Саратовская область",
      "parent_id": 87,
      "nsi_id": 25,
      "dm_region_id": 267,
      "gisp_id": 3523,
      "id": 64
    },
    {
      "code": "65",
      "name": "Сахалинская область",
      "parent_id": 87,
      "nsi_id": 9,
      "dm_region_id": 232,
      "gisp_id": 3525,
      "id": 65
    },
    {
      "code": "66",
      "name": "Свердловская область",
      "parent_id": 87,
      "nsi_id": 62,
      "dm_region_id": 252,
      "gisp_id": 3526,
      "id": 66
    },
    {
      "code": "67",
      "name": "Смоленская область",
      "parent_id": 87,
      "nsi_id": 80,
      "dm_region_id": 221,
      "gisp_id": 3529,
      "id": 67
    },
    {
      "code": "68",
      "name": "Тамбовская область",
      "parent_id": 87,
      "nsi_id": 81,
      "dm_region_id": 220,
      "gisp_id": 3531,
      "id": 68
    },
    {
      "code": "69",
      "name": "Тверская область",
      "parent_id": 87,
      "nsi_id": 82,
      "dm_region_id": 226,
      "gisp_id": 3533,
      "id": 69
    },
    {
      "code": "70",
      "name": "Томская область",
      "parent_id": 87,
      "nsi_id": 59,
      "dm_region_id": 253,
      "gisp_id": 3534,
      "id": 70
    },
    {
      "code": "71",
      "name": "Тульская область",
      "parent_id": 87,
      "nsi_id": 83,
      "dm_region_id": 192,
      "gisp_id": 3535,
      "id": 71
    },
    {
      "code": "72",
      "name": "Тюменская область",
      "parent_id": 87,
      "nsi_id": 63,
      "dm_region_id": 210,
      "gisp_id": 3537,
      "id": 72
    },
    {
      "code": "73",
      "name": "Ульяновская область",
      "parent_id": 87,
      "nsi_id": 26,
      "dm_region_id": 216,
      "gisp_id": 3539,
      "id": 73
    },
    {
      "code": "74",
      "name": "Челябинская область",
      "parent_id": 87,
      "nsi_id": 64,
      "dm_region_id": 218,
      "gisp_id": 3543,
      "id": 74
    },
    {
      "code": "75",
      "name": "Забайкальский край",
      "parent_id": 87,
      "nsi_id": 53,
      "dm_region_id": 244,
      "gisp_id": 3480,
      "id": 75
    },
    {
      "code": "76",
      "name": "Ярославская область",
      "parent_id": 87,
      "nsi_id": 84,
      "dm_region_id": 228,
      "gisp_id": 3548,
      "id": 76
    },
    {
      "code": "77",
      "name": "Москва",
      "parent_id": 87,
      "nsi_id": 85,
      "dm_region_id": 196,
      "gisp_id": 3505,
      "id": 77
    },
    {
      "code": "78",
      "name": "Санкт-Петербург",
      "parent_id": 87,
      "nsi_id": 37,
      "dm_region_id": 265,
      "gisp_id": 3522,
      "id": 78
    },
    {
      "code": "79",
      "name": "Еврейская автономная область",
      "parent_id": 87,
      "nsi_id": 11,
      "dm_region_id": 224,
      "gisp_id": 3479,
      "id": 79
    },
    {
      "code": "82",
      "name": "Республика Крым",
      "parent_id": 87,
      "nsi_id": 92,
      "dm_region_id": 260,
      "gisp_id": 3497,
      "id": 80
    },
    {
      "code": "83",
      "name": "Ненецкий автономный округ",
      "parent_id": 87,
      "nsi_id": 38,
      "dm_region_id": 259,
      "gisp_id": 3508,
      "id": 81
    },
    {
      "code": "86",
      "name": "Ханты-Мансийский автономный округ - Югра",
      "parent_id": 87,
      "nsi_id": 65,
      "dm_region_id": 233,
      "gisp_id": 3542,
      "id": 82
    },
    {
      "code": "87",
      "name": "Чукотский автономный округ",
      "parent_id": 87,
      "nsi_id": 10,
      "dm_region_id": 261,
      "gisp_id": 3546,
      "id": 83
    },
    {
      "code": "89",
      "name": "Ямало-Ненецкий автономный округ",
      "parent_id": 87,
      "nsi_id": 66,
      "dm_region_id": 204,
      "gisp_id": 3547,
      "id": 84
    },
    {
      "code": "92",
      "name": "Севастополь",
      "parent_id": 87,
      "nsi_id": 93,
      "dm_region_id": 273,
      "gisp_id": 3527,
      "id": 85
    },
    {
      "code": "94",
      "name": "Иные территории, включая город и космодром Байконур",
      "parent_id": 87,
      "nsi_id": 96,
      "dm_region_id": 202,
      "gisp_id": null,
      "id": 86
    }
  ]
}
